import TypeAhead from './type-ahead';
export default TypeAhead;
export type { TypeAheadOption, TypeAheadFilterResult } from './type-ahead';
